import { useSelector } from "react-redux";

export const ToggleButton = props => {
    const { values, value, onChange, disabled, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);
       
    return (
        <div className="toggle-container">
            {
                values.map((item, index) => {
                    let selectedClassName = "";

                    if (Array.isArray(value))
                         selectedClassName = value[item.id-1] == false ? "not-selected" : "selected";
                    else
                        selectedClassName = value && value==item.id ? "selected" : "not-selected";
             
                    return (
                        <div key={index} className={`toggle-button toggle-${item.id} ${selectedClassName} ${disabled ? "disabled" : null}`} 
                             onClick={e => !disabled ? onChange(e, item) : () => {}}
                        >
                            {item.title}
                        </div>
                    );
                    
                })
            }
            <style>
                {
                    `
                        .toggle-container
                        {
                            display: inline-flex;
                            border: 1.5px solid ${currentTheme.primary};
                            border-radius:6px;
                            background-color: ${currentTheme.toggleTrackBgColor};
                            padding: 4px 4px;
                        }

                        .toggle-button
                        {                            
                            padding: 2px 16px;                            
                            border: 1px solid ${currentTheme.componentBg};
                            border-radius:10px;
                        }

                        .toggle-button.selected
                        {
                            background-color: ${currentTheme.toggleSelectedBgColor};
                            color: ${currentTheme.toggleSelectedColor};
                        }

                        .toggle-button.unselected
                        {
                            background-color: ${currentTheme.toggleTrackBgColor};
                            color: ${currentTheme.toggleUnSelectedColor};
                        }

                        .toggle-button:not(.disabled):hover
                        {
                            cursor: pointer;
                            background-color: ${currentTheme.toggleSelectedBgColor};
                            color: ${currentTheme.toggleSelectedColor};
                        }

                        /*.toggle-button.selected:not(.disabled):hover
                        {
                            cursor: pointer;
                            background-color:red;
                            color: ${currentTheme.toggleSelectedColor};
                        }*/
                    `
                }
            </style>
        </div>
    );
};

export const FormToggleButton = fieldRendererProps =>{
    const {values, value, onChange, disabled, ...other} = fieldRendererProps;

    const handleOnSetChecks = (e, item) => {
        let checks = values;

        if(disabled)
           return;

        if(Array.isArray(value))
        {
            let arr = value.map((element, index) => {
                if (index == item.id - 1)
                    return !element;
                else
                    return element;
               });
            onChange({value: arr}, {value: arr});
        }
        else
        {
           if (value == values[0].id)            
               onChange({value:values[1].id}, {value:values[1].id});
            else
                onChange({value:values[0].id}, {value:values[0].id});
        }
    };

    return (
        <ToggleButton values={values} value={value} onChange={handleOnSetChecks} disabled={disabled} {...other}  />
    );
};